<template>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-2 ps-3 pb-2 mb-1 border-bottom">
	<h4 class="fs-4 m-0">Сесії користувача "{{ getUserName(userId) }}"</h4>
</div>

<easy-data-table
	class="data-table m-1 mt-0 me-1"
	table-class-name="customize-table"
	:headers="tableHeader"
	:items="tableItems"
	theme-color="rgb(198, 199, 200)"
	must-sort="true"
	:sort-by="sessionStore.sessionSchema.lastActivity"
	:sort-type="'desc'" 
	:rows-items="[40,100,200,400,1000]"
	:rows-per-page="rowsPerPage"
	:key="rowsPerPage"
	rows-per-page-message="записів на сторінці"
	rows-of-page-separator-message=" з "
	:table-min-height="380"
	:table-height="easyDataTableHeight()"
	:prevent-context-menu-row="false"
	alternating
	buttons-pagination
	body-expand-row-class-name="expand-row-no-background"
	@expand-row="sessionDetails"
	:body-row-class-name="getRowClass"
>
	<!-- If rows is empty -->
	<template #empty-message>
		Користувач не заходив на сайт
	</template>

	<!-- IP item customization -->
	<template #[`item-${sessionStore.fingerprintsSchema.ip}`]="item">
		<span class="fw-semibold">{{ item[sessionStore.fingerprintsSchema.ip] ? item[sessionStore.fingerprintsSchema.ip] : '-' }}</span>
	</template>

	<!-- Start time item customization -->
	<template #[`item-${sessionStore.sessionSchema.startTime}`]="item">
		{{ item[sessionStore.sessionSchema.startTime] ? dateTimeToString(item[sessionStore.sessionSchema.startTime], false) : '-' }}
	</template>

	<!-- Last activity item customization -->
	<template #[`item-${sessionStore.sessionSchema.lastActivity}`]="item">
		{{ item[sessionStore.sessionSchema.lastActivity] ? dateTimeToString(item[sessionStore.sessionSchema.lastActivity], false) : '-' }}
	</template>

	<!-- Stop time item customization -->
	<template #[`item-${sessionStore.sessionSchema.stopTime}`]="item">
		{{ item[sessionStore.sessionSchema.stopTime] ? dateTimeToString(item[sessionStore.sessionSchema.stopTime], false) : '-' }}
	</template>

	<!-- Location item customization -->
	<template #[`item-${sessionStore.fingerprintsSchema.location}`]="item">
		{{ item[sessionStore.fingerprintsSchema.country] }},
		{{ item[sessionStore.fingerprintsSchema.region] }},
		{{ item[sessionStore.fingerprintsSchema.city] }},
		<a
			v-if="item[sessionStore.fingerprintsSchema.location]"
			:href="`https://www.google.com/maps/search/?api=1&query=${item[sessionStore.fingerprintsSchema.location][0]},${item[sessionStore.fingerprintsSchema.location][1]}`"
			target="_blank"
		>
			{{ item[sessionStore.fingerprintsSchema.location] }}
		</a>
	</template>

	<!-- Browser item customization -->
	<template #[`item-${sessionStore.fingerprintsSchema.browser}`]="item">
		{{ item[sessionStore.fingerprintsSchema.platform] }}, {{ item[sessionStore.fingerprintsSchema.browser] }}
	</template>

	<!-- Language item customization -->
	<template #[`item-${sessionStore.fingerprintsSchema.language}`]="item">
		{{ item[sessionStore.fingerprintsSchema.language] ? getLanguageName(item[sessionStore.fingerprintsSchema.language]) : '' }}
	</template>

	<template #expand="item">
		<!-- Table in expandable item -->
		<div style="padding: 0px; padding-left: 10px; background-color: inherit;">
			<easy-data-table
				id="no-scroll-table"
				class="data-table"
				table-class-name="customize-table"
				:headers="tableHeader"
				:items="item.expand"
				:rows-per-page="60"
				theme-color="rgb(198, 199, 200)"
				:sort-by="sessionStore.sessionSchema.lastActivity"
				:sort-type="'desc'"
				hide-footer="true"
			>
				<template #customize-headers>
				</template>

				<!-- IP item customization -->
				<template #[`item-${sessionStore.fingerprintsSchema.ip}`]="item">
					<span class="fw-semibold">
						{{ item[sessionStore.fingerprintsSchema.ip] ? item[sessionStore.fingerprintsSchema.ip] : '-' }}
					</span>
				</template>

				<!-- Start time item customization -->
				<template #[`item-${sessionStore.sessionSchema.startTime}`]="item">
					<span class="invisible">
					{{ item[sessionStore.sessionSchema.startTime] ? dateTimeToString(item[sessionStore.sessionSchema.startTime], false) : '-' }}
					</span>
				</template>

				<!-- Last activity item customization -->
				<template #[`item-${sessionStore.sessionSchema.lastActivity}`]="item">
					<span class="invisible">
					{{ item[sessionStore.sessionSchema.lastActivity] ? dateTimeToString(item[sessionStore.sessionSchema.lastActivity], false) : '-' }}
					</span>
				</template>

				<!-- Stop time item customization -->
				<template #[`item-${sessionStore.sessionSchema.stopTime}`]="item">
					<span class="invisible">
					{{ item[sessionStore.sessionSchema.stopTime] ? dateTimeToString(item[sessionStore.sessionSchema.stopTime], false) : '-' }}
					</span>
				</template>

				<!-- Location item customization -->
				<template #[`item-${sessionStore.fingerprintsSchema.location}`]="item">
					{{ item[sessionStore.fingerprintsSchema.country] }},
					{{ item[sessionStore.fingerprintsSchema.region] }},
					{{ item[sessionStore.fingerprintsSchema.city] }},
					<a
						v-if="item[sessionStore.fingerprintsSchema.location]"
						:href="`https://www.google.com/maps/search/?api=1&query=${item[sessionStore.fingerprintsSchema.location][0]},${item[sessionStore.fingerprintsSchema.location][1]}`"
						target="_blank"
					>
						{{ item[sessionStore.fingerprintsSchema.location] }}
					</a>
				</template>

				<!-- Browser item customization -->
				<template #[`item-${sessionStore.fingerprintsSchema.browser}`]="item">
					<span class="invisible">
					{{ item[sessionStore.fingerprintsSchema.platform] }}, {{ item[sessionStore.fingerprintsSchema.browser] }}
					</span>
				</template>

				<!-- Language item customization -->
				<template #[`item-${sessionStore.fingerprintsSchema.language}`]="item">
					<span class="invisible">
					{{ item[sessionStore.fingerprintsSchema.language] ? getLanguageName(item[sessionStore.fingerprintsSchema.language]) : '' }}
					</span>
				</template>
			</easy-data-table>
		</div>
	</template>
</easy-data-table>
</template>


<script>
import { useAccontStore } from '@/stores/AccountStore.js'
import { useSessionStore } from '@/stores/SessionStore.js'
import { useAccounts } from '@/composables/accounts.js'
import {
	capitalizeFirstLetter,
	dateTimeToString,
	easyDataTableRowsPerPage,
	easyDataTableHeight,
} from '@/helpers.js'


export default {
	inject: ['developerId'],

	waitAfterExecuteSuccessMs: 3100,
	requiredPromt: 'Обов\'язкове поле',
	overMinLen: 'Довжина меньше мінімальної',
	overMaxLen: 'Довжина більше максимальної',

	components: {},

	props: {},

	emits: {},

	setup() {
		const accountStore = useAccontStore()
		const sessionStore = useSessionStore()
		const { getUserName } = useAccounts()

		return {
			capitalizeFirstLetter,
			dateTimeToString,
			easyDataTableHeight,

			accountStore,
			sessionStore,

			getUserName,
		}
	},

	data() {
		return {
			// User ID
			userId: null,
			//
			sessions: [],
			// Table
			rowsPerPage: 20,
		}
	},
	
	async created() {
		// Read id from url
		try {
			this.userId = this.$route.params.id
		} catch {
			console.error("On user id read.")
			return
		}

		this.sessions = await this.sessionStore.getUserSessions(this.userId)
	},

	async mounted() {
		document.title = "Сесії"
		this.rowsPerPage = easyDataTableRowsPerPage()
	},

	methods: {
		getLanguageName (languageCode, displayLocale = 'uk') {
			try {
				const displayNames = new Intl.DisplayNames([displayLocale], { type: 'language' });
				return displayNames.of(languageCode);
			} catch (error) {
				console.error("Error converting language code:", error);
				return ''
			}
		},

		getRowClass(row) {
			return row[this.sessionStore.fingerprintsSchema.ipHistory] && row[this.sessionStore.fingerprintsSchema.ipHistory].length > 1
				? ''
				: 'no-expand';
		},

		sessionDetails(index) {
			const sessionItem = this.tableItems[index]
			// console.log('expandable item', sessionItem)
			sessionItem.expand = []
			const baseArray = sessionItem[this.sessionStore.fingerprintsSchema.ipHistory]

			if (!baseArray || baseArray.length == 0) {
				return
			}

			for (const [i, ] of baseArray.entries()) {
				sessionItem.expand.push({
					[this.sessionStore.fingerprintsSchema.ip]: sessionItem[this.sessionStore.fingerprintsSchema.ipHistory][i],
					[this.sessionStore.sessionSchema.startTime]: sessionItem[this.sessionStore.sessionSchema.startTime],
					[this.sessionStore.sessionSchema.lastActivity]: sessionItem[this.sessionStore.sessionSchema.lastActivity],
					[this.sessionStore.sessionSchema.stopTime]: sessionItem[this.sessionStore.sessionSchema.stopTime],
					[this.sessionStore.fingerprintsSchema.location]: sessionItem[this.sessionStore.fingerprintsSchema.locationHistory][i],
					[this.sessionStore.fingerprintsSchema.country]: sessionItem[this.sessionStore.fingerprintsSchema.countryHistory][i],
					[this.sessionStore.fingerprintsSchema.region]: sessionItem[this.sessionStore.fingerprintsSchema.regionHistory][i],
					[this.sessionStore.fingerprintsSchema.city]: sessionItem[this.sessionStore.fingerprintsSchema.cityHistory][i],
					[this.sessionStore.fingerprintsSchema.platform]: sessionItem[this.sessionStore.fingerprintsSchema.platform],
					[this.sessionStore.fingerprintsSchema.browser]: sessionItem[this.sessionStore.fingerprintsSchema.browser],
					[this.sessionStore.fingerprintsSchema.language]: sessionItem[this.sessionStore.fingerprintsSchema.language],
					[this.sessionStore.fingerprintsSchema.browserId]:  sessionItem[this.sessionStore.fingerprintsSchema.browserId],
				})
			}

			return false
		},
	},

	computed: {
		tableHeader() {
			const header = [
				{ text: "IP", value: this.sessionStore.fingerprintsSchema.ip, sortable: true, },
				{ text: "Початок", value: this.sessionStore.sessionSchema.startTime, sortable: true, },
				{ text: "Остання активність", value: this.sessionStore.sessionSchema.lastActivity, sortable: true, },
			]

			if (this.accountStore.isPrimary && this.accountStore.userId == this.developerId) {
				header.push({ text: "Кінець", value: this.sessionStore.sessionSchema.stopTime, sortable: true, })
			}

			header.push({ text: "Розташування", value: this.sessionStore.fingerprintsSchema.location, sortable: true, })
			header.push({ text: "Браузер", value: this.sessionStore.fingerprintsSchema.browser, sortable: true, })
			header.push({ text: "Мова", value: this.sessionStore.fingerprintsSchema.language, sortable: true, })				
		
			if (this.accountStore.isPrimary && this.accountStore.userId == this.developerId) {
				header.push({
					text: 'Browser ID',
					value: this.sessionStore.fingerprintsSchema.browserId,
					sortable: true,
				})
			}

			return header
		},

		tableItems() {
			return this.sessions
		},
	},
}
</script>


<style src="@/assets/table.css" scoped />
<style scoped>
</style>

<style>
#no-scroll-table .vue3-easy-data-table__main {
	/* overflow: hidden !important; */
	overflow: visible !important;
	max-height: 100% !important;
	display: block;
}

/* Manual background set */
#no-scroll-table tr {
	background-color: #fff;
}
#no-scroll-table .even-row {
	/* background-color: inherit !important; */
	background-color: #eee !important;
}

/* Make expand button invisible */
tr.no-expand td.can-expand .expand-icon {
	display: none !important;
}

/* Disable expand button press */
tr.no-expand td.can-expand {
	pointer-events: none;
}
</style>